import { endOfDay, getHours, getMinutes, isAfter, isBefore, isSameDay, startOfDay } from 'date-fns';
import { type DatePickerDateType, getDateType } from '../date-picker';

export function disabledDate({ maximum, minimum }: { maximum?: Date; minimum?: Date }) {
  if (minimum && maximum) {
    return (dateTimePickerDate: DatePickerDateType) => {
      const option = getDateType(dateTimePickerDate);

      return isBefore(endOfDay(option), startOfDay(minimum)) || isAfter(startOfDay(option), endOfDay(maximum));
    };
  }

  if (minimum) {
    return (dateTimePickerDate: DatePickerDateType) => {
      const option = getDateType(dateTimePickerDate);

      return isBefore(endOfDay(option), startOfDay(minimum));
    };
  }

  if (maximum) {
    return (dateTimePickerDate: DatePickerDateType) => {
      const dateVersionOption = getDateType(dateTimePickerDate);

      return isAfter(startOfDay(dateVersionOption), endOfDay(maximum));
    };
  }

  return undefined;
}

export function disabledTime({ maximum, minimum }: { maximum?: Date; minimum?: Date }) {
  return (dateTimePickerDate: DatePickerDateType) => {
    const option = getDateType(dateTimePickerDate);

    if (maximum && isSameDay(option, maximum) && minimum && isSameDay(option, minimum)) {
      return {
        disabledHours: () => [...range(0, getHours(minimum)), ...range(getHours(maximum) + 1, 24)],
        disabledMinutes(hour: number) {
          if (hour === getHours(minimum) && hour === getHours(maximum)) {
            return [...range(0, getMinutes(minimum)), ...range(getMinutes(maximum) + 1, 60)];
          }

          if (hour === getHours(minimum)) {
            return range(0, getMinutes(minimum));
          }

          if (hour === getHours(maximum)) {
            return range(getMinutes(maximum) + 1, 60);
          }

          return [];
        },
      };
    }

    if (minimum) {
      if (isSameDay(option, minimum)) {
        return {
          disabledHours: () => range(0, getHours(minimum)),
          disabledMinutes(hour: number) {
            if (hour === getHours(minimum)) {
              return range(0, getMinutes(minimum));
            }

            return [];
          },
        };
      }

      if (isBefore(option, minimum)) {
        return {
          disabledHours: () => range(0, 24),
          disabledMinutes: () => range(0, 60),
        };
      }
    }

    if (maximum) {
      if (isSameDay(option, maximum)) {
        return {
          disabledHours: () => range(getHours(maximum) + 1, 24),
          disabledMinutes(hour: number) {
            if (hour === getHours(maximum)) {
              return range(getMinutes(maximum) + 1, 60);
            }

            return [];
          },
        };
      }

      if (isAfter(option, maximum)) {
        return {
          disabledHours: () => range(0, 24),
          disabledMinutes: () => range(0, 60),
        };
      }
    }

    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
    };
  };
}

function range(start: number, end: number) {
  const result = [];
  for (let index = start; index < end; index++) {
    result.push(index);
  }

  return result;
}
